import React from "react";
import { FaPlus } from "react-icons/fa";

/**
 * FormButton — minimal primary action button for page/panel headers.
 * Uses the global .btn .btn-primary .app-action-button styles.
 */
export const FormButton = ({ button_name, onClick, type = "button", disabled = false }) => {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className="btn btn-primary btn-sm app-action-button"
        >
            <FaPlus size={11} aria-hidden="true" />
            {button_name}
        </button>
    );
};
